// ==============================|| OVERRIDES - LINK ||============================== //

import BbLinkBehavior from "@/components/building-blocks/controls/BbLinkBehavior"

export default function Link() {
    return {
        MuiLink: {
            defaultProps: {
                underline: "none",
                component: BbLinkBehavior,
            },
        },
    }
}
